import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { WishlistProvider } from './context/WishlistContext';
import { CartProvider } from './context/CartContext';
import { MotionProvider } from './context/MotionContext';
import { StoreStatusProvider } from './context/StoreStatusContext';
import ThemeSync from './components/ThemeSync';

import Layout from './components/Layout';
import AdminLayout from './components/AdminLayout';

import HomePage from './pages/HomePage';
import ShopPage from './pages/ShopPage';
import ProductPage from './pages/ProductPage';
import CartPage from './pages/CartPage';
import ShippingPage from './pages/ShippingPage';
import InfluencerPortalPage from './pages/InfluencerPortalPage';
import InfluencerPage from './pages/InfluencerPage';
import AdminInfluencersPage from './pages/admin/AdminInfluencersPage';
import CheckoutPage from './pages/CheckoutPage';
import OrderConfirmationPage from './pages/OrderConfirmationPage';
import OrderLookupPage from './pages/OrderLookupPage';
import UnsubscribePage from './pages/UnsubscribePage';
import AccountLayout from './pages/account/AccountLayout';
import OrdersTab from './pages/account/OrdersTab';
import WishlistTab from './pages/account/WishlistTab';
import RequestsTab from './pages/account/RequestsTab';
import BankingTab from './pages/account/BankingTab';
import LoginPage from './pages/LoginPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import Placeholder from './pages/Placeholder';
import TemplatesPage from './pages/TemplatesPage';
import LabsPage from './pages/LabsPage';
import AdminProductsPage from './pages/admin/AdminProductsPage';
import AdminProductEditPage from './pages/admin/AdminProductEditPage';
import AdminAddChoicePage from './pages/admin/AdminAddChoicePage';
import BulkUploadPage from './pages/admin/BulkUploadPage';
import AdminCategoriesPage from './pages/admin/AdminCategoriesPage';
import AdminShippingBoxesPage from './pages/admin/AdminShippingBoxesPage';
import AdminPayoutsPage from './pages/admin/AdminPayoutsPage';
import AdminOrdersPage from './pages/admin/AdminOrdersPage';
import AdminAnalyticsPage from './pages/admin/AdminAnalyticsPage';
import AdminFulfillmentPage from './pages/admin/AdminFulfillmentPage';

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <StoreStatusProvider>
        <WishlistProvider>
        <CartProvider>
        <MotionProvider>
          <BrowserRouter>
            <ThemeSync />
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<HomePage />} />
                <Route path="/shop" element={<ShopPage />} />
                <Route path="/product/:slug" element={<ProductPage />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/shipping" element={<ShippingPage />} />
                <Route path="/influencers" element={<InfluencerPortalPage />} />
                <Route path="/influencer" element={<InfluencerPage />} />
                <Route path="/order/lookup" element={<OrderLookupPage />} />
                <Route path="/unsubscribe" element={<UnsubscribePage />} />
                <Route path="/order/:token" element={<OrderConfirmationPage />} />
                <Route path="/account" element={<AccountLayout />}>
                  <Route index element={<Navigate to="orders" replace />} />
                  <Route path="orders" element={<OrdersTab />} />
                  <Route path="wishlist" element={<WishlistTab />} />
                  <Route path="requests" element={<RequestsTab />} />
                  <Route path="banking" element={<BankingTab />} />
                </Route>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
              </Route>

              <Route path="/templates" element={<TemplatesPage />} />
              <Route path="/labs" element={<LabsPage />} />

              <Route path="/admin" element={<AdminLayout />}>
                <Route path="products" element={<AdminProductsPage />} />
                <Route path="products/add" element={<AdminAddChoicePage />} />
                <Route path="products/bulk" element={<BulkUploadPage />} />
                <Route path="products/:id" element={<AdminProductEditPage />} />
                <Route path="categories" element={<AdminCategoriesPage />} />
                <Route path="orders" element={<AdminOrdersPage />} />
                <Route path="analytics" element={<AdminAnalyticsPage />} />
                <Route path="fulfillment" element={<AdminFulfillmentPage />} />
                <Route path="influencers" element={<AdminInfluencersPage />} />
                <Route path="shipping-boxes" element={<AdminShippingBoxesPage />} />
                <Route path="payouts" element={<AdminPayoutsPage />} />
              </Route>

              <Route path="*" element={<Placeholder title="Not found" note="That page doesn't exist." />} />
            </Routes>
          </BrowserRouter>
        </MotionProvider>
        </CartProvider>
        </WishlistProvider>
        </StoreStatusProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
